<template>
  <block style="padding-bottom: 60px;">
    <template slot="header">
      Nueva Atención
    </template>

    <p class="question has-text-weight-semibold is-uppercase is-size-6">
      ¿desea planificar una atención o agregar una atención ya realizada?
    </p>
    <div class="actions">
      <button class="button is-primary" @click="navigateTo('app.profile.new_attention')">
        Planificar próxima atención
      </button>
      &nbsp;
      <button class="button is-primary" @click="navigateTo('app.profile.new_past_attention')">
        Agregar atención realizada
      </button>
    </div>
  </block>
</template>

<script>
import Block from "@/components/_base/Block.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileAddAttention",
  mixins: [OverlayedMixin],
  components: {
    Block
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    }
  }
}
</script>

<style scoped>
.question {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}
.button {
  padding: 0 20px;
}
</style>
